import { useTranslations } from "next-intl"

import Notebook from "~/public/static/images/svg/notebook.svg"
import TwoUsers from "~/public/static/images/svg/twoUsers.svg"
import ShieldCheck from "~/public/static/images/svg/shieldCheck.svg"
import HandShake from "~/public/static/images/svg/handShake.svg"
import HandMoney from "~/public/static/images/svg/handMoney.svg"
import NumberOneRibbon from "~/public/static/images/svg/numberOneRibbon.svg"


const usePoints = () => {
  const translate = useTranslations('traffic.whyUseUs.items')

  return [
    {
      title: translate('submit.title'),
      imgSrc: Notebook,
      text: translate('submit.description')
    },
    {
      title: translate('attorneys.title'),
      imgSrc: TwoUsers,
      text: translate('attorneys.description')
    },
    {
      title: translate('insuranceProtection.title'),
      imgSrc: ShieldCheck,
      text: translate('insuranceProtection.description')
    },
    {
      title: translate('setAndForget.title'),
      imgSrc: HandShake,
      text: translate('setAndForget.description')
    },
    {
      title: translate('noSurprises.title'),
      imgSrc: HandMoney,
      text: translate('noSurprises.description')
    },
    {
      title: translate('trackAndCommunicate.title'),
      imgSrc: NumberOneRibbon,
      text: translate('trackAndCommunicate.description')
    }
  ]
}

export default usePoints
